export const accessTypes = ['public', 'private', 'protected'] as const;
export type AccessType = (typeof accessTypes)[number];

export const materializationTypes = [
  'table',
  'view',
  'incremental',
  'ephemeral',
  'materialized view',
] as const;
export type MaterializationType = (typeof materializationTypes)[number];

export const CUSTOM_MATERIALIZATION_TYPE = 'custom' as const;

export const CUSTOM_MATERIALIZATION_NO_MATCH_SENTINEL =
  '__dbt_materialization_no_match__' as const;

export const filterMaterializationTypes = [
  ...materializationTypes,
  CUSTOM_MATERIALIZATION_TYPE,
] as const;
export type FilterMaterializationType = (typeof filterMaterializationTypes)[number];

export const modelingLayerTypes = ['intermediate', 'marts', 'staging'] as const;

export type ModelingLayerType = (typeof modelingLayerTypes)[number];
